<template>
  <div class="formBox-contents-row">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormBoxItemRow',
};
</script>

<style lang="scss" scoped>

.formBox-contents-row {
  display: contents;

  @include pad-width() {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
}

</style>
